import React, { useState, useEffect } from "react";
import Header from "../Components/Header";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";

const EditBillDate = () => {
    const navigate = useNavigate();
    const { order_id } = useParams();
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

    const [products, setProducts] = useState({
        product_code: "",
        product_name: "",
        unit: "",
        box_content: "",
        rate_per: "",
        //stock: "",
        tax: "",
        supplier_id: "",
        supplier_name: "",

    });

    const [categories, setCategories] = useState([]);
    const [brands, setBrands] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [selectedCategory, setSelectedCategory] = useState("");
    const [selectedBrand, setSelectedBrand] = useState("");
    const [supplier, setSupplier] = useState([]);
    const [selectedsupplier, setSelectedSupplier] = useState("");
    const [billDate, setBillDate] = useState("");



    const [formData, setFormData] = useState({ bill_date: "" });

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response = await axios.post(`${API_BASE_URL}billdate_detail.php`,
                {
                    order_id: order_id,     // existing order ID
                     
                });
                if (response.data && response.data.body) {
                    const productData = response.data.body.added_date;
                    setFormData({ bill_date: productData });
                } else {
                    setError("No data found");
                }
            } catch (error) {
                setError("Failed to fetch data");
            } finally {
                setLoading(false);
            }
        };

        fetchProducts();
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };


    const handleUpdate = async (event) => {
        event.preventDefault();

        try {
            const response = await axios.post(
                `${API_BASE_URL}billdate_update.php`,
                {
                    order_id: order_id,     // existing order ID
                     new_date: formData.bill_date     // new bill date
                }
            );

            if (response.data.head.code === 200) {
                alert("Product updated successfully!");
                // navigate("/products");
                window.history.back();
            } else {
                alert("Update failed: " + response.data.head.msg);
            }
        } catch (error) {
            alert("Failed to update product.");
        }
    };

    if (loading) return <p> </p>;
    if (error) return <p className="text-danger">{error}</p>;

    return (
        <>
            <Header />
            <div className="page-wrapper compact-wrapper" id="pageWrapper">
                <div className="page-body-wrapper">
                    <div className="page-body">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="title-header option-title d-sm-flex d-block">
                                                <h5>Edit Bill Date</h5>
                                                <div className="right-options">
                                                    <ul>
                                                        <li>
                                                            <Link
                                                                className="btn btn-solid"
                                                                onClick={() => window.history.back()}
                                                            >
                                                                Back
                                                            </Link>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>

                                            <form className="theme-form theme-form-2 mega-form" onSubmit={handleUpdate}>
                                                <div className="row">


                                                    {/* Product Name */}
                                                    <div className="col-md-6">
                                                        <div className="mb-4">
                                                            <label>Bill Date</label>
                                                            <input
                                                                required
                                                                className="form-control"
                                                                type="text"
                                                                name="bill_date"
                                                                placeholder="Enter Bill Date"
                                                                value={formData.bill_date || ""}
                                                                onChange={handleInputChange}
                                                            />

                                                        </div>
                                                    </div>




                                                </div>

                                                {/* Submit and Cancel Buttons */}
                                                <div className="d-flex justify-content-end">
                                                    <button className="btn btn-primary me-3" type="submit">
                                                        Submit
                                                    </button>
                                                    <button
                                                        className="btn btn-outline"
                                                        type="button"
                                                        onClick={() => window.history.back()}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            </form>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EditBillDate;
